// this is the data layer of the app
// in time we should make all backend calls through this interface
// in order to unify all the data access in one place
// also, it's a place to do:
// - data transformation
// - data sanitization
// - chain backend calls
// BFF: Backend for frontend.
// Agent: Data access proxy object

import { Login } from './BFF/BFF_login'
import { Dashboard } from './BFF/BFF_dashboard/'
import { Datamasters } from './BFF/BFF_datamasters/'
import { Catalogs } from './BFF/BFF_catalogs/'
import { Files } from './BFF/BFF_files/'
import { Simulador } from './BFF/BFF_simulador/'
import { Peritador } from './BFF/BFF_peritador/'
import { Presupuestador } from './BFF/BFF_presupuestador/'
import { GestionOperativa } from './BFF/BFF_gestion_operativa/'
import { Cotizador } from './BFF/BFF_cotizador/'
import { Clients } from './BFF/BFF_clients/'
import { Sales } from './BFF/BFF_sales'
import { Locations } from './BFF/BFF_locations'
import { User } from './BFF/BFF_user'
import { Stock } from './BFF/BFF_stock'
import { Sirena } from './BFF/BFF_sirena'
import { Commission } from './BFF/BFF_commission'
import { PricePolicy } from './BFF/BFF_price_policy'
import { SoliVenta } from './BFF/BFF_solicitud_venta'
import { Payments } from './BFF/BFF_payments'
import { Plans } from './BFF/BFF_plans'
import { Integrations } from './BFF/BFF_integrations'
import { FairPrice } from './BFF/BFF_fair_price'
import { Leads } from './BFF/BFF_leads'
import { Framework } from './BFF/BFF_framework'
import { SavingsPlan } from './BFF/BFF_savings_plan'
import { Notifications } from 'BFF/BFF_notifications/index'

export const BFFAgent = {
  Login,
  Dashboard,
  Datamasters,
  Catalogs,
  Files,
  Simulador,
  Peritador,
  Presupuestador,
  GestionOperativa,
  Cotizador,
  Clients,
  Sales,
  Locations,
  User,
  Stock,
  Sirena,
  Commission,
  PricePolicy,
  SoliVenta,
  Payments,
  Plans,
  Integrations,
  FairPrice,
  Leads,
  Framework,
  SavingsPlan,
  Notifications
}
